export type SortingQueryKey = 'best-selling' | 'title-ascending';
export const SORTINGQUERY = {
  ['best-selling']: {
    sortBy: 'best_selling',
    sortDirection: 'DESC',
  },
  ['title-ascending']: {
    sortBy: 'product_name',
    sortDirection: 'ASC',
  },
  ['title-descending']: {
    sortBy: 'product_name',
    sortDirection: 'DESC',
  },
  ['price-ascending']: {
    sortBy: 'sell_price',
    sortDirection: 'ASC',
  },
  ['price-descending']: {
    sortBy: 'sell_price',
    sortDirection: 'DESC',
  },
  ['created-ascending']: {
    sortBy: 'modified_at',
    sortDirection: 'ASC',
  },
  ['created-descending']: {
    sortBy: 'modified_at',
    sortDirection: 'DESC',
  },
};

export const SORTINGCOLLECTIONLIST = {
  ['title-ascending']: {
    sortBy: 'collection_name',
    sortDirection: 'asc',
  },
  ['title-descending']: {
    sortBy: 'collection_name',
    sortDirection: 'desc',
  },
  ['price-ascending']: {
    sortBy: 'total_products',
    sortDirection: 'asc',
  },
  ['price-descending']: {
    sortBy: 'total_products',
    sortDirection: 'desc',
  },
  ['created-ascending']: {
    sortBy: 'created_at',
    sortDirection: 'asc',
  },
  ['created-descending']: {
    sortBy: 'created_at',
    sortDirection: 'desc',
  },
};
